import { FormPageButton } from "../components/FormPageButton";
import { Link } from "react-router-dom";
import { TrSpace } from "../components/TrSpace";

export const NotFound = () => {
    return (
        <div className='flex flex-col min-h-screen'>
                <main className="flex-grow">
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>404 Page Not Found</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <table>
                            <tbody>
                                <tr><td><p className="text-sm md:text-base px-40">お探しのページが見つかりませんでした</p></td></tr>
                                <TrSpace/>
                                <TrSpace/>
                            </tbody>
                        </table>
                        <Link to="/">
                            <FormPageButton text="ホームへ戻る"/>
                        </Link>
                    </div>
                </main>
        </div>
    );
};